export * from 'react-native-web';

export const AsyncStorage = () => undefined;
export const MaskedViewIOS = () => undefined;
export const ViewPagerAndroid = () => undefined;
export const ViewPropTypes = {};
export default () => {};
